import { StrategyStat, formatDuration, percent } from '@/lib/actModes'
import { cn } from '@/lib/utils'

/**
 * Which moves actually land. Not a rating he guessed at afterward -- the hit
 * rate of every question he led with that move, next to what it costs him.
 */
export default function ActStrategyTable({ strategies }: { strategies: StrategyStat[] }) {
  const rows = strategies.filter(s => s.used > 0)
  if (rows.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Run some questions in Strategy mode and I'll show you which moves are earning their keep.
      </p>
    )
  }

  return (
    <div className="border border-border rounded-xl divide-y divide-border overflow-hidden">
      {rows.map(row => (
        <div key={row.tagKey} className="px-3 py-3 space-y-1.5">
          <div className="flex items-baseline justify-between gap-3">
            <p className="text-sm font-medium">{row.label}</p>
            <p className="text-sm font-bold tabular-nums shrink-0">
              {row.graded > 0 ? percent(row.accuracy) : '—'}
            </p>
          </div>
          <div className="h-1.5 rounded-full bg-accent overflow-hidden">
            <div
              className={cn(
                'h-full',
                row.accuracy >= 0.7 ? 'bg-green-500' : row.accuracy >= 0.5 ? 'bg-primary' : 'bg-amber-500'
              )}
              style={{ width: `${Math.round(row.accuracy * 100)}%` }}
            />
          </div>
          <p className="text-[11px] text-muted-foreground">
            used {row.used} {row.used === 1 ? 'time' : 'times'} · {formatDuration(row.avgSeconds)} a question
          </p>
        </div>
      ))}
    </div>
  )
}
